import React from 'react'
import CalenderContent from '../components/calender/CalenderContent'

const AppsCalender = () => {
    return (
        <>
            <CalenderContent />
        </>
    )
}

export default AppsCalender